import API from '../api';
import commonAction from './commonAction';

const api = new API();

export const loadTasksActual = () => {
	return dispatch => commonAction(dispatch, 'post', '/task/actual', null, 'LOAD_TASKS_ACTUAL', 'data');
};

export const loadTasksFinished = () => {
	return dispatch => commonAction(dispatch, 'post', '/task/finished', null, 'LOAD_TASKS_FINISHED', 'data');
};

export const addTask = data => {
	return dispatch => commonAction(dispatch, 'post', '/task/add', data, 'ADD_TASK', 'data');
}

export const updateTask = (data, id) => {
	return dispatch => commonAction(dispatch, 'post', '/task/update', data, 'UPDATE_TASK', 'data', id);
}

export const removeTask = id => {
	return dispatch => commonAction(dispatch, 'post', '/task/delete', { id }, 'REMOVE_TASK', 'data');
}


// WEBPACK FOOTER //
// ./actions/tasksActions.js